export const calendarPeriodsRoutes = [
  {
    path: '/payrollsConfig/:id/calendarPeriods',
    name: 'calendarPeriods',
    component: () =>
      import('@/modules/calendarPeriods/views/ListCalendarPeriodsGroups.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarPeriods/add',
    name: 'calendarPeriods/add',
    component: () => import('./views/CreateCalendarPeriodsGroup.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarPeriods/detail/:calendarPeriodId',
    name: 'calendarPeriods/detail',
    component: () => import('./views/CalendarPeriodsDetails.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
